import { forwardRef, type PropsWithChildren } from 'react'
import classNames from 'classnames'
import { WButton } from '@alice-health/wonderland-react'

import { ClassName } from '@/global/types'
import { Conditional } from '@/global/components/Conditional'
import { Portal } from '@/global/components/Portal'
import { useDrawer } from '@/global/hooks'

export interface DrawerProps {
  id: string
  className?: ClassName
  fullWidth?: boolean
  rounded?: boolean
  backGroundColor?: ClassName
  closeButton?: boolean
}

export const Drawer = forwardRef<
  HTMLDivElement,
  PropsWithChildren<DrawerProps>
>(function Drawer(
  {
    id,
    children,
    className,
    fullWidth = false,
    rounded = false,
    backGroundColor = 'bg-gl-color-shades-white',
    closeButton = false
  },
  ref
) {
  const { isOpen, close } = useDrawer(id)

  return (
    <Conditional
      if={isOpen}
      then={
        <Portal wrapperId={id}>
          <div
            ref={ref}
            id={id}
            data-testid={id}
            className={classNames(
              'fixed shadow-sm',
              backGroundColor,
              fullWidth ? 'w-screen' : 'w-fit',
              rounded && 'rounded-gl-border-radius-lg',
              className
            )}
          >
            {closeButton ? (
              <WButton
                className='absolute top-0 right-0 mt-gl-spacing-04 mr-gl-spacing-06'
                iconButton
                icon='icClose'
                variant='secondary'
                size='medium'
                onClick={() => close()}
              />
            ) : null}

            {children}
          </div>
        </Portal>
      }
    />
  )
})
